import { BaseController } from '../../common/base/controller';

export class ErrorController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({
      controllerService,
    });
  }

  $onInit() {
    this.id = this.$stateParams.id;
    this.requestId = this.$stateParams.requestId;
  }
}
